import "./SimilarityScore.scss";

import { OverlayTrigger } from "react-bootstrap";

import { InfoIcon } from "../../../../components/icons";
import { renderTooltip } from "../../../../components/StyledTooltip/StyledTooltip";
import { formatPercentage } from "../../../../utils/NumbersFormatting";

interface SimilarityScoreProps {
  scoreType: string | null;
  score: string | null;
}

const SimilarityScore: React.FC<SimilarityScoreProps> = ({
  scoreType,
  score,
}) => {
  const isExactMatch = scoreType === "exact-match";

  const scoreValue = score ? formatPercentage(1 - Number(score)) : 0;

  return scoreType ? (
    <div className="playground-score">
      {isExactMatch ? "Exact match" : "Similarity score"}
      {score ? `: ${scoreValue}` : null}
      <OverlayTrigger
        placement="top"
        overlay={renderTooltip(
          isExactMatch
            ? "This cache hit was an exact match"
            : `This cache hit was a similar match with a score of ${scoreValue}`,
        )}
      >
        <span data-testid="tooltip">
          <InfoIcon />
        </span>
      </OverlayTrigger>
    </div>
  ) : null;
};

export { SimilarityScore };
